import React, {useState, useEffect} from "react"
import ImageGallery from 'react-image-gallery'

// data
import data from "../../data";

// styling
import "./Testimonials.scss"

function Testimonials({mode}) {
  return null;
  /*
  // state
  const [items, setItems] = useState([])
  const [imagesLoaded, setImagesLoaded] = useState(false)

  // mount gather items
  useEffect(() => {
    // gather items
    let _items = data.Testimonials.get().map((testimonial, index) => {
      return {
        original:testimonial.imageUrl,
        thumbnail:testimonial.imageUrl
      }
    })
    setItems(_items)
  }, [])

  // preload first image
  useEffect(() => {
    if(items.length > 0 && !imagesLoaded) {
      const imageElement = new Image()
      imageElement.onload = onImageLoaded
      imageElement.src = items[0].original
    }
  }, [items])

  // image load event handler
  const onImageLoaded = () => {
    setImagesLoaded(true)
  }
  

  let title = mode === "mobile" ? <h2>Kundenmeinungen</h2> : null

  if(!imagesLoaded) {
    return null
  }
  else {
    return (
      <div className="c-testimonials">
        {title}
        <ImageGallery 
          items={items}  
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={false}
        />
      </div>
    )
  }
  */
}

export default Testimonials